import { Smartphone, Zap, Search, Sparkles, Gauge, LifeBuoy } from "lucide-react";
import { WHY_HIRE_ME } from "@/data/portfolio";
import { useReveal } from "@/hooks/useReveal";

const iconMap = { Smartphone, Zap, Search, Sparkles, Gauge, LifeBuoy };

export default function WhyHireMe() {
  const { ref, visible } = useReveal();
  return (
    <section id="why" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10" ref={ref}>
        <div className={`max-w-2xl mb-12 fade-in-up ${visible ? "in" : ""}`}>
          <div className="section-label mb-4">Why Hire Me</div>
          <h2 className="heading-hero text-4xl md:text-5xl lg:text-6xl">
            Not just a developer — a<br/>
            <span className="text-[#FF3B30]">growth partner.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_HIRE_ME.map((w, i) => {
            const Icon = iconMap[w.icon] || Sparkles;
            return (
              <div
                key={w.title}
                className={`glass-card rounded-3xl p-7 fade-in-up ${visible ? "in" : ""}`}
                style={{ transitionDelay: `${i * 60}ms` }}
                data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 grid place-items-center text-[#FF3B30] mb-5">
                  <Icon size={20} />
                </div>
                <h3 className="font-display font-bold text-lg mb-2">{w.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
